import React, { useState } from "react";
import { useGetProspectSuspectListQuery } from "../../store/services/customerService";
import CustomerListBase from "./components/CustomerListBase";
import ProspectContextMenu, {
  ProspectAction,
} from "./components/ProspectContextMenu";
import { MyCustomerApiResponse } from "../../store/services/customerService";
import {
  CustomerDataField,
  DEFAULT_CUSTOMER_COLUMNS,
  mergeColumnConfigs,
} from "./components/CustomerColumnConfig";
import AssignSalesDialog from "../dialogs/AssignSales";

const ProspectSuspectList: React.FC = () => {
  const { data = [], error, isLoading, isFetching } =
    useGetProspectSuspectListQuery();
  const [contextMenu, setContextMenu] = useState<{
    mouseX: number;
    mouseY: number;
    customer: MyCustomerApiResponse;
  } | null>(null);

  const [assignSalesDialog, setAssignSalesDialog] = useState<{
    open: boolean;
    customerNo: number;
  } | null>(null);

  // Custom context menu handler for Prospect/Suspect list
  const handleContextMenu = (
    customer: MyCustomerApiResponse,
    event: React.MouseEvent
  ) => {
    event.preventDefault();
    setContextMenu({
      mouseX: event.clientX,
      mouseY: event.clientY,
      customer,
    });
  };

  // Handle closing the context menu
  const handleCloseContextMenu = () => {
    setContextMenu(null);
  };

  // Handle actions from the prospect context menu
  const handleProspectAction = (action: ProspectAction) => {
    const customer = contextMenu?.customer;
    if (!customer) return;

    switch (action) {
      case "markAsLead":
        console.log(`Mark ${customer.Name} as lead`);
        // Implement lead marking logic
        break;
      case "convertToCustomer":
        console.log(`Convert ${customer.Name} to customer`);
        // Implement conversion logic
        break;
      case "assignToSalesRep":
        setAssignSalesDialog({
          open: true,
          customerNo: customer.Id,
        });
        // Show sales rep assignment dialog
        break;
    }

    handleCloseContextMenu();
  };

  const customColumns = mergeColumnConfigs(DEFAULT_CUSTOMER_COLUMNS, [
    // Ändra existerande kolumner
    { field: CustomerDataField.CONSUMPTION, visible: false }, // Dölj förbrukning
    { field: CustomerDataField.LAST_LOGIN, visible: false }, // Dölj förbrukning
    { field: CustomerDataField.SALES_REP, visible: true, priority: 3 }, // Visa säljare
    // Lägg till en ny kolumn
    {
      field: CustomerDataField.POSTAL_CITY,
      headerLabel: "Ort",
      visible: true,
      sortable: true,
      priority: 5,
    },
  ]);

  return (
    <>
      <CustomerListBase
        customers={data}
        isLoading={isLoading}
        isFetching={isFetching}
        error={error}
        columnConfig={customColumns}
        renderContextMenu={handleContextMenu}
      />

      {/* Render the Prospect-specific context menu */}
      <ProspectContextMenu
        contextMenu={contextMenu}
        onClose={handleCloseContextMenu}
        onAction={handleProspectAction}
      />
      {assignSalesDialog && (
        <AssignSalesDialog
          open
          customerNo={assignSalesDialog.customerNo}
          onClose={() => setAssignSalesDialog(null)}
        />
      )}
    </>
  );
};

export default ProspectSuspectList;
